app.directive('fullscreenBlock', ['$compile', '$filter', function ($compile, $filter) {

	var jqLite = angular.element;

    var link = function (scope, element, attrs) {
        var tooltipLibelle = $filter('translate')('agrandir_le_tableau');
        var fullscreenButton = function () {
            return jqLite($compile(
                '<button class="large circular ui icon grey button color-white full-screen-btn" ng-click="fullscreenMode($event)"  data-tooltip="'+tooltipLibelle+'"data-position="top left">'+
    				'<i class="expand icon"></i>'+
    			'</button>'
            )(scope));
        };

        if(angular.isDefined(attrs.fullscreenButton) && $(attrs.fullscreenButton)[0]){
            $(attrs.fullscreenButton).each(function() {
                if($(this).children('button.full-screen-btn').length === 0) { // Si le bouton n'existe pas déjà
                    angular.element($(this)).append((attrs.fullscreenBlock.length > 0) ? attrs.fullscreenBlock : fullscreenButton());
                }
            });
        } else {
            element.prepend((attrs.fullscreenBlock.length > 0) ? attrs.fullscreenBlock : fullscreenButton());
        }
    };

	// Function to find the first parent element
    var closest = function (element) {
        return (jqLite(element).parent().attr('fullscreen-block') !== undefined) ?
            jqLite(element).parent() :
            closest(jqLite(element).parent());
    };

    return {
        link: link,
        controller: ['$scope', '$timeout', function ($scope) {
	        // Handles click event
	        $scope.fullscreenMode = function (event) {
	            var modalWrapper = '<modal-wrapper></modal-wrapper>';
	            jqLite(closest(event.target)).wrap(modalWrapper);
	            $compile(modalWrapper)($scope);
	        };
	    }]
    }
}]);
